import { createModel } from "@reduck/core";
import { getUserInfo } from "@/apis/user";
import { setLocale } from "@/common/starling";

declare module "@reduck/core" {
  interface ModelsContext {
    common: CommonModel;
  }
}

export interface UserInfo {
  id: number;
  type: number;
  username: string;
  nickname: string;
  avatar: string;
  email: string;
  isInternal: boolean;
  isBpo: boolean;
  userType: number;
}

export interface PermissionInfo {
  project_id: number;
  project_name: string;
  deta_time: number;
  roles: string;
  start_time: string;
  status: string;
}

export interface ProjectInfo {
  id: number;
  aliases: string;
  archived: boolean;
  audit_state: number;
  belong_to: number;
  bug_platform: string;
  bug_workspace_id: string;
  commonProjectId: number;
  dev_type: string;
  editable: boolean;
  gfProjectId: number;
  icon: string;
  meego_operator: {
    user_id: number;
    open_id: string;
    username: string;
    nickname: string;
    user_type: number;
    avatar: string;
    email: string;
  };
  merged: boolean;
  name: string;
  operate_area: string;
  operate_center: string;
  platform: string;
  pro_bundle_id: string;
  proj_type: number;
  project_stage: string;
  review_meta: {
    project_id: number;
    extra_accounts: any;
    is_no_app_id: boolean;
    aid: number;
    bundle_id: string;
    team_name: string;
    gp_developer_id: string;
    package_name: string;
    rocket_app_id: string;
  };
  secrecy: number;
  studio: string;
}

interface State {
  /** 当前语言 */ lang: string;
  /** 用户信息 */ userInfo: UserInfo;
  /** 项目信息 */ projectInfo: ProjectInfo;
}

interface ComputedState {
  projectID: number;
}

export type CommonModel = typeof commonModel;

const initalUserInfo = {
  id: 0,
  type: 0,
  username: "",
  nickname: "",
  avatar: "",
  email: "",
  isInternal: true,
  isBpo: false,
  userType: 0,
  openId: "",
};

export const commonModel = createModel<State, ComputedState>("common").define({
  // 初始 Model 状态
  state: {
    lang: "zh-CN",
    userInfo: initalUserInfo,
    projectInfo: {
      id: 0,
      aliases: "",
      archived: false,
      audit_state: 2,
      belong_to: 0,
      bug_platform: "",
      bug_workspace_id: "",
      commonProjectId: 0,
      dev_type: "",
      editable: false,
      gfProjectId: 0,
      icon: "",
      meego_operator: {
        user_id: 0,
        open_id: "",
        username: "",
        nickname: "",
        user_type: 0,
        avatar: "",
        email: "",
      },
      merged: false,
      name: "",
      operate_area: "",
      operate_center: "",
      platform: "",
      pro_bundle_id: "",
      proj_type: 0,
      project_stage: "",
      review_meta: {
        project_id: 0,
        extra_accounts: [],
        is_no_app_id: false,
        aid: 0,
        bundle_id: "",
        team_name: "",
        gp_developer_id: "",
        package_name: "",
        rocket_app_id: "",
      },
      secrecy: 0,
      studio: "",
    },
  },
  computed: {
    projectID: ({ projectInfo }) => {
      return projectInfo.id || 0;
    },
  },

  actions: {
    setUserInfo(state, val: UserInfo) {
      state.userInfo = val;
    },
    clearUserInfo(state) {
      state.userInfo = initalUserInfo;
    },
    setProjectInfo(state, val: ProjectInfo) {
      state.projectInfo = val;
    },
  },

  effects: (_, { models }) => {
    return {
      /** 初始化 */
      init: async () => {
        const { state, actions } = models.common;

        const { setUserInfo, setProjectInfo } = actions;
        if (
          !["/login", "/signout", "/", "/noPermission/download",].includes(
            location.pathname,
          )
        ) {
          const { userInfo, defaultProjectID } = await getUserInfo();
          setUserInfo(userInfo);
          // setLocale(userInfo?.userType !== 5 ? 'zh-CN' : 'en');
          if (!state.projectInfo.id) {
            console.log(1,defaultProjectID,"22")
            setProjectInfo({...state.projectInfo, id: defaultProjectID });
          }
        }

        window?.Slardar("init", {
          bid: "gameflow",
          env:
            window.location.hostname === "gameflow.bytedance.com"
              ? "production"
              : "test", // 区分不同环境
        });
        window?.Slardar("start");

        return models.common.state;
      },
    };
  },
});
